import { render, staticRenderFns } from "./DetailHeader.vue?vue&type=template&id=acad513e&scoped=true"
import script from "./DetailHeader.vue?vue&type=script&lang=js"
export * from "./DetailHeader.vue?vue&type=script&lang=js"
import style0 from "./DetailHeader.vue?vue&type=style&index=0&id=acad513e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acad513e",
  null
  
)

export default component.exports